/*eslint-disable no-undef,no-redeclare,no-empty,no-unused-vars */
import April from '../../ALizard/April'

export default ()=>{
    April.define("log.critical", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.critical" });
            args.tweener
                .call(function(_args){
                    phina.display.Sprite( // TODO 暫定
                        'img/ui/critical.png'
                    ).setSize(100,46).addChildTo(ch)
                    .setPosition(-20,-20)
                    .tweener
                        .wait(1000)
                        .fadeOut(100)
                        .call(function(){ this.remove(); });
                }, null, [args]);
        }
    });
    April.define("log.debug-damage", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP-=args.damage;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP+=args.damage;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.debug-damage" });
            args.tweener
                .call(function(_args){
                    ch.HP -= _args.damage;
                }, null, [args])
                .call(function(_args){
                    ShakeEffect().attachTo(ch);
                })
                .call(function(_args){
                    DebugCounter({
                        value: _args.damage,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        digitStyle: _args.color||'n',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
    April.define("log.damage", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP-=args.damage;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP+=args.damage;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.debug-damage" });
            args.tweener
                .call(function(_args){
                    ch.HP -= _args.damage;
                }, null, [args])
                .call(function(_args){
                    ShakeEffect().attachTo(ch);
                })
                .call(function(_args){
                    SmashCounter({
                        value: _args.damage,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        digitStyle: _args.color||'n',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
    April.define("DisplayComponent/attack.slash-damage", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP-=args.value;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP+=args.value;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.debug-damage" });
            args.tweener
                .call(function(_args){
                    ch.HP -= _args.value;
                }, null, [args])
                .call(function(_args){
                    ShakeEffect().attachTo(ch);
                })
                .call(function(_args){
                    SlashCounter({
                        value: _args.value,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        digitStyle: _args.color||'n',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
    April.define("DisplayComponent/attack.thrust-damage", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP-=args.value;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP+=args.value;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.debug-damage" });
            args.tweener
                .call(function(_args){
                    ch.HP -= _args.value;
                }, null, [args])
                .call(function(_args){
                    ShakeEffect().attachTo(ch);
                })
                .call(function(_args){
                    ThrustCounter({
                        value: _args.value,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        digitStyle: _args.color||'n',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
    April.define("DisplayComponent/attack.shock-damage", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP-=args.value;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP+=args.value;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.debug-damage" });
            args.tweener
                .call(function(_args){
                    ch.HP -= _args.value;
                }, null, [args])
                .call(function(_args){
                    ShakeEffect().attachTo(ch);
                })
                .call(function(_args){
                    ShockCounter({
                        value: _args.value,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        digitStyle: _args.color||'n',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
    April.define("log.action", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
        }else if(args.opr == 'back'){
        }else if(args.opr == 'play'){
            var scene=args.scene;
            scene.flare("act_console", { value: "call DisplayComponent/attack.action" });
            args.tweener
                .wait(args.delay);
        }
    });
    April.define("log.break", function(args){
      if(args.opr == 'split'){
          return false;
      }else if(args.opr == 'next'){
      }else if(args.opr == 'back'){
      }else if(args.opr == 'play'){
          var scene=args.scene;
          var ch = args.scene.member[args.player];
          scene.flare("act_console", {value:"call DisplayComponent/attack.break", args: args});
          args.tweener
          .call(function(_args){
              BattleScene.Fukidasi("img/ui/F_exp.png", 110, 55)
              .addChildTo(ch).setPosition(0,0);
          }, null, [args]);
      }
    });

    April.define("DisplayComponent/attack.chain", function(param){
      if(param.opr == 'split'){
          return false;
      }else if(param.opr == 'next'){
        param.code.forEach(function(v, i){
          April.call(v.call,{
            opr: param.opr,
            scene: param.scene,
            tweener: param.tweener,
          }.$extend(v.args));
        });
      }else if(param.opr == 'back'){
        param.code.forEach(function(v, i){
          April.call(v.call,{
            opr: param.opr,
            scene: param.scene,
            tweener: param.tweener,
          }.$extend(v.args));
        });
      }else if(param.opr == 'play'){
          var scene=param.scene;
          var ch = param.scene.member[param.player];
          scene.flare("act_console", { value: "call DisplayComponent/attack.chain", args:param });
          param.code.forEach(function(v, i){
            April.call(v.call,{
              opr: param.opr,
              scene: param.scene,
              tweener: param.tweener,
            }.$extend(v.args));
          });
    /*
          param.tweener
              .call(function(_args){
                _args.code.forEach(function(v, i){
                  April.call(v.call,{
                    opr: _args.opr,
                    scene: _args.scene,
                    tweener: _args.tweener,
                  }.$extend(v.args));
                });
              }, null, [param]);
    */
      }
    });

    April.define("DisplayComponent/attack.bless-damage", function(args){
        if(args.opr == 'split'){
            return false;
        }else if(args.opr == 'next'){
            args.scene.member[args.player].HP-=args.value;
        }else if(args.opr == 'back'){
            args.scene.member[args.player].HP+=args.value;
        }else if(args.opr == 'play'){
            var scene=args.scene;
            var ch = args.scene.member[args.player];
            scene.flare("act_console", { value: "call DisplayComponent/attack.debug-damage" });
            args.tweener
                .call(function(_args){
                    ch.HP -= _args.value;
                }, null, [args])
                .call(function(_args){
                    ShakeEffect().attachTo(ch);
                })
                .call(function(_args){
                    BlessCounter({
                        value: _args.value,
                        digitFont: "img/ui/font13.png",
                        digitWidth: 30,
                        digitHeight: 45,
                        direction: -ch.reverse,
                        digitStyle: _args.color||'n',
                    }).addChildTo(ch).setPosition(0,0);
                }, null, [args]);
        }
    });
}
